/**
 * Photos — first on the inspection page: taken as the device comes out of
 * the bag, before it is handled. Guided shots per device type
 * (`INSPECTION_SCHEMA`); only the serial label photo — or "No visible serial"
 * — is required. A sealed box is just the side of the box with the label.
 */

import React from 'react';
import type { CheckInPhoto } from '@techgitter/contracts';

import {
  SEALED_BOX_SERIAL_SHOT,
  type InspectionSchemaEntry,
} from '../../../../utils/inspectionSchema';
import { PhotoCapture } from '../PhotoCapture';

export interface PhotosSectionProps {
  sessionId: string;
  draftJobId: string;
  photos: CheckInPhoto[];
  schema: InspectionSchemaEntry;
  brandNewInBox: boolean;
  noVisibleSerial: boolean;
  onNoVisibleSerialChange: (value: boolean) => void;
  /** A photo is waiting on the AI rig's label reading. */
  readingPending?: boolean;
  readOnly?: boolean;
  onPhotosChanged: () => void;
}

export const PhotosSection: React.FC<PhotosSectionProps> = ({
  sessionId,
  draftJobId,
  photos,
  schema,
  brandNewInBox,
  noVisibleSerial,
  onNoVisibleSerialChange,
  readingPending = false,
  readOnly = false,
  onPhotosChanged,
}) => (
  <div className="ci-section">
    {!readOnly && !brandNewInBox && (
      <div className="ci-caption">
        Photograph the device before handling it. Only the serial label is required; the
        other shots build the condition report, and Areas of interest are for close-ups.
      </div>
    )}
    {!readOnly && readingPending && (
      <div className="ci-caption">Reading the label — make and serial fill in when found.</div>
    )}
    <PhotoCapture
      sessionId={sessionId}
      draftJobId={draftJobId}
      photos={photos}
      serialShot={brandNewInBox ? SEALED_BOX_SERIAL_SHOT : schema.serialShot}
      shots={brandNewInBox ? [] : schema.photoShots}
      noVisibleSerial={noVisibleSerial}
      onNoVisibleSerialChange={onNoVisibleSerialChange}
      readOnly={readOnly}
      onPhotosChanged={onPhotosChanged}
    />
  </div>
);
